//import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useLoc = () => {
    //return useLocation().pathname.replace(/\//g, '');
    return useLocation().pathname;
};
